module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/avatar/avatar.component.scss
// module id = ./src/app/modules/common-module/components/avatar/avatar.component.scss
// module chunks = 9